<mat-card class="despacho-content">
  <mat-card-header class="imprimir-container">
    <h1 class="!mb-4" style="font-size: 20px;font-weight: 500;">DESPACHO</h1>
  </mat-card-header>
  <mat-card-content>
    <mat-card>
      <mat-card-content>
        <form [formGroup]="nuevoDespacho" class="w-full">
          <h3 class="heading-3 !mt-3">Nuevo Tema</h3>
          <mat-form-field class="w-full">
            <mat-label>Tema</mat-label>
            <input
              required
              formControlName="nombreTema"
              name="nombreTema"
              class="w-full"
              type="text"
              minlength="1"
              maxlength="1000"
              matInput />

            <mat-hint align="end"
              >{{
                nuevoDespacho.get("nombreTema")?.value
                  ? nuevoDespacho.get("nombreTema")?.value.length
                  : 0
              }}
              / 1000</mat-hint
            >
            @if (nuevoDespacho.get('nombreTema')?.invalid &&
            nuevoDespacho.get('nombreTema')?.touched) {
            <mat-error>Campo obligatorio.</mat-error>
            }
          </mat-form-field>
          <div class="grid grid-cols-2 gap-4">
            <mat-form-field class="flex-grow" *ngIf="catEmpresa">
              <mat-label>Empresa</mat-label>
              <mat-select
                formControlName="empresa"
                name="empresa"
                onsel
                (valueChange)="seleccionarEmpresa($event)">
                <mat-option value="-1" disabled="true"
                  >Seleccione una empresa.</mat-option
                >
                @for (empresa of catEmpresa; track empresa) {
                <mat-option [disabled]="empresa.disabled" [value]="empresa">{{
                  empresa.descripcion
                }}</mat-option>
                }
              </mat-select>
              @if (nuevoDespacho.get('empresa')?.invalid &&
              nuevoDespacho.get('empresa')?.touched) {
              <mat-error>Campo obligatorio.</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="flex-grow" *ngIf="catTipoDespacho">
              <mat-label>Tipo de Despacho</mat-label>
              <mat-select
                formControlName="id_tipo_despacho"
                name="id_tipo_despacho">
                <mat-option value="-1" disabled="true"
                  >Seleccione un despacho.</mat-option
                >
                @for (tipo of catTipoDespacho; track tipo) {
                <mat-option [value]="tipo.id">{{
                  tipo.descripcion
                }}</mat-option>
                }
              </mat-select>
              @if (nuevoDespacho.get('id_tipo_despacho')?.invalid &&
              nuevoDespacho.get('id_tipo_despacho')?.touched) {
              <mat-error>Campo obligatorio.</mat-error>
              }
            </mat-form-field>
          </div>
          <section
            class="detalle-section-entradas"
            *ngIf="
              nuevoDespacho.get('entradas')?.value &&
              nuevoDespacho.get('entradas')?.value.length > 0
            ">
            <!-- Encabezados de columnas -->
            <div class="grid grid-cols-3 gap-4 bg-gray-200 p-2 font-bold">
              <div class="container-material col-span-1">
                <p>Material</p>
              </div>
              <div class="container-entregables col-span-1">
                <p>Entregables</p>
              </div>
              <div class="container-archivos col-span-1">
                <p>Archivos Adjuntos</p>
              </div>
            </div>

            <!-- Iteración sobre las entradas -->
            @for (entrada of nuevoDespacho.get('entradas')?.value; track
            entrada) {
            <div
              class="grid grid-cols-3 gap-4 bg-white border border-gray-300 p-2">
              <!-- Columna de material -->
              <div class="material col-span-1">
                <a
                  routerLink="/entrada/{{ entrada.id_categorizacion }}/{{
                    entrada.id_entrada
                  }}"
                  target="_blank"
                  #tooltip="matTooltip"
                  [matTooltip]="entrada.nombreEntradaCompleto"
                  matTooltipPosition="above"
                  aria-label="nombreEntradanombreEntrada"
                  class="entradaLink !underline"
                  matTooltipClass="tooltip-full-width">
                  {{ entrada.nombreEntrada }}
                </a>
              </div>

              <!-- Entregables -->
              <div class="entregables col-span-1">
                <div
                  *ngFor="let entregable of entrada.entregables; let j = index">
                  <div
                    class="estatus-container flex gap-1 justify-between items-center"
                    *ngIf="
                      entregable.id_edo_entregable !== 5 &&
                      entregable.id_edo_entregable !== 6
                    ">
                    @if (entregable.nombreEntregable.trim() !== '') {
                    <a
                      href="{{ entregable.urlEntregable }}"
                      target="_blank"
                      #tooltip="matTooltip"
                      [matTooltip]="entregable.nombreEntregable"
                      matTooltipPosition="above"
                      aria-label="Button that displays a tooltip that hides when scrolled out of the container"
                      class="example-button !underline"
                      matTooltipClass="tooltip-full-width">
                      {{
                        entregable.nombreEntregable.length > 22
                          ? entregable.nombreEntregable.substring(0, 22) + "..."
                          : entregable.nombreEntregable
                      }}
                    </a>
                    }@else {
                    <a
                      (click)="
                        descargaEntregable(
                          entregable.id_entrada,
                          entregable.id_entregable
                        )
                      "
                      class="!underline !cursor-pointer"
                      ng-if="entregable.nombreEntregable.trim() === ''">
                      Adjuntar Archivos
                    </a>
                    }
                  </div>
                </div>
              </div>

              <!-- Archivos -->
              <div class="archivos col-span-1 flex justify-between gap-3">
                @if (entrada.archivos.length>0) {

                <div class="col-span-1 w-full">
                  @for (archivo of entrada.archivos; track $index) {
                  <div
                    class="archivo flex justify-between gap-3 pb-1 col-span-1 w-full">
                    <a
                      href="{{ archivo.url }}"
                      target="_blank"
                      #tooltip="matTooltip"
                      [matTooltip]="archivo.nombre_archivo"
                      matTooltipPosition="above"
                      aria-label="Button that displays a tooltip that hides when scrolled out of the container"
                      class="example-button !underline"
                      matTooltipClass="tooltip-full-width">
                      {{
                        archivo.nombre_archivo.length > 22
                          ? archivo.nombre_archivo.substring(0, 22) + "..."
                          : archivo.nombre_archivo
                      }}
                    </a>
                    <a
                      href="{{ archivo.url }}"
                      target="_blank"
                      mat-mini-fab
                      color="primary"
                      aria-label="Remove file">
                      <mat-icon>remove_red_eye</mat-icon>
                    </a>
                  </div>
                  }
                </div>
                }@else {
                <p></p>
                }

                <div class="actions col-span-1 flex justify-end">
                  <button
                    (click)="removeEntrada(entrada)"
                    mat-mini-fab
                    color="warn"
                    aria-label="Remove file">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>

              <!-- <div class="actions col-span-1 flex-1">
               
              </div> -->
            </div>
            }
          </section>

          <section class="detalle-section-tres" style="margin-top: 2rem">
            <div
              class="select-custom-entradas"
              style="width: 100%; position: relative"
              *ngIf="entradasState">
              <mat-form-field class="example-full-width" style="width: 100%">
                <mat-label>Buscar Entrada</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input
                  [disabled]="disabled(entradasState)"
                  type="text"
                  aria-label="Number"
                  formControlName="entradaSelected"
                  name="entradaSelected"
                  matInput
                  (input)="onInput($event, nuevoDespacho)"
                  (focus)="onFocus(nuevoDespacho)"
                  (blur)="onBlur(nuevoDespacho)" />
              </mat-form-field>

              <ul
                *ngIf="
                  nuevoDespacho.get('entradaSelected')?.value !== '' ||
                  mostrarEntradas
                "
                class="custom-dropdown">
                @if (listaEntradas.length>0) {
                <li *ngFor="let entrada of listaEntradas">
                  <button (click)="selectEntrada(entrada, listaEntradas)">
                    {{ entrada.nombreEntradaCompleto }}
                  </button>
                </li>
                } @else {
                <li class="!p-2">No se encuentra la entrada.</li>
                }
              </ul>
            </div>
          </section>
        </form>
        <mat-card-actions align="end" class="nuevo-catalogo-actions">
          <button (click)="cancelar()" mat-stroked-button class="!uppercase">
            CANCELAR
          </button>
          <button
            [disabled]="
              nuevoDespacho.get('entradas')?.value.length == 0 ||
              nuevoDespacho.get('nombreTema')?.value == '' ||
              nuevoDespacho.get('id_empresa')?.value == '' ||
              nuevoDespacho.get('id_tipo_despacho')?.value == ''
            "
            (click)="guardarDespacho()"
            mat-flat-button
            class="!uppercase"
            color="primary">
            ACEPTAR
          </button>
        </mat-card-actions>
        <p></p>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>
